import {ACCESS_TOKEN, API_BASE_URL} from "../constants";
import * as axios from "axios";
import jwtDecode from "jwt-decode";

const request = (options) => {
    const headers = {};
    if (options.isDownload) {
        headers["responseType"] = "arraybuffer";
        delete options.isDownload;
    }
    headers["Content-Type"] = "application/json;charset=UTF-8";
    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers["Authorization"] = "Bearer " + localStorage.getItem(ACCESS_TOKEN);
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    return axios(options);
};

export function fetchRequest(requestData, url, cancelToken) {
    return request({
        url: API_BASE_URL + url,
        method: "POST",
        cancelToken: cancelToken,
        data: requestData,
    });
}

export function getRequest(url, cancelToken) {
    return request({
        url: API_BASE_URL + url,
        method: "GET",
        cancelToken: cancelToken,
    });
}

export function isAuthenticateValid() {
    if (isTokenExpired()) {
        localStorage.clear();
        return false;
    }
    return true;
}

export function isTokenExpired() {
    let token = getIdToken();
    if (token && 'undefined' !== token) {
        let decoded = jwtDecode(token);
        let current_time = Date.now() / 1000;
        return decoded.exp < current_time;
    } else {
        return true;
    }
}

export function getIdToken() {
    const idToken = localStorage.getItem(ACCESS_TOKEN);
    if (!idToken) {
        console.log("ERROR: no id token found!");
    }
    return idToken;
}

export function login(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/get-token",
        method: "POST",
        data: loginRequest,
    });
}

export function getCurrentUser() {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: API_BASE_URL + "/auth/me",
        method: "GET",
    });
}

export function getUserProfile(username) {
    return request({
        url: API_BASE_URL + "/auth/" + username,
        method: "GET",
    });
}

export function getActiveCampaigns(pageNumber, pageSize) {
    return request({
        url: API_BASE_URL + "/campaign/getAllActiveCampaign?page=" + pageNumber + "&size=" + pageSize,
        method: "GET",
    });
}

export function getCampaignDetail(name) {
    return request({
        url: API_BASE_URL + "/campaign/getCampaignDetail",
        method: "post",
        data: name
    });
}

export function register(requestData) {
    return request({
        url: API_BASE_URL + "/auth/register",
        method: "POST",
        data: requestData,
    });
}

export function forgotPassword(requestData) {
    return request({
        url: API_BASE_URL + "/auth/forgotPassword",
        method: "POST",
        data: requestData,
    });
}

export function resetPassword(requestData) {
    return request({
        url: API_BASE_URL + "/auth/resetPassword?token=" + requestData,
        method: "POST",
    });
}

export function savePassword(requestData) {
    return request({
        url: API_BASE_URL + "/auth/savePassword",
        method: "POST",
        data: requestData,
    });
}

export function applyGeneralCampaignForm(requestData) {
    return request({
        url: API_BASE_URL + "/form/applyGeneralCampaignForm",
        method: "POST",
        data: requestData,
    });
}

export function applyFuelCampaignForm(requestData) {
    return request({
        url: API_BASE_URL + "/form/applyFuelCampaign",
        method: "POST",
        data: requestData,
    });
}

export function pharmacyIdCardApplication(requestData) {
    return request({
        url: API_BASE_URL + "/pharmacyIdCard/application",
        method: "POST",
        data: requestData,
    });
}

export function requestCampaignCode(requestData) {
    return request({
        url: API_BASE_URL + "/campaign/requestCode?campaignCodeType=" + requestData,
        method: "POST",
    });
}

export function updateCampaignDetail(requestData) {
    return request({
        url: API_BASE_URL + "/campaign/updateCampaign",
        method: "POST",
        data: requestData,
    });
}

export function addCampaign(requestData) {
    return request({
        url: API_BASE_URL + "/campaign/addCampaign",
        method: "POST",
        data: requestData,
    });
}

export function deleteCampaign(requestData) {
    return request({
        url: API_BASE_URL + "/campaign/deleteCampaign?" + "campaignId=" + requestData ,
        method: "POST",
    });
}
export function addCampaignImage(requestData) {
    return request({
        url: API_BASE_URL + "/campaignImage/upload",
        method: "POST",
        data: requestData,
    });
}
export function updateCampaignImage(requestData) {
    return request({
        url: API_BASE_URL + "/campaignImage/update",
        method: "POST",
        data: requestData,
    });
}

export function addUser(requestData) {
  return request({
    url: API_BASE_URL + "/form/addCampaigns",
    method: "POST",
    data: requestData,
  });
}

export function updatesUser(requestData,id) {
  return request({
    url: API_BASE_URL + "/form/updateFuelsCampaign/"+(id == undefined ? -1 : id),
    method: "POST",
    data: requestData,
  });
}

export function updateAllUser(requestData,record_id) {
  return request({
    url: API_BASE_URL + "/form/updateUser/"+record_id,
    method: "POST",
    data: requestData,
  });
}

export function logUpdateUserInfo(requestData, record_id) {
   return request({
      url: API_BASE_URL + "/form/userlog/"+record_id,
      method: "POST",
      data: requestData,
    });
}







// WEBPACK FOOTER //
// ./src/util/APIUtils.js